<template>
  <v-container fluid>
    <rcp-data-table 
      :items="rcps"
      :loading="loading"
      @recharge="getRcps()"
      @switchProcessamentosExpirados="
        processamentosExpirados = $event,
        getRcps()
      "
    /> 
  </v-container>
</template>

<script>
import RcpService from '@/services/RcpService';
import dayjs from 'dayjs';
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    RcpDataTable: () => import('@/components/rcp/RcpDataTable')
  },
  mixins: [pusherMixins, tourMixins],

  data() {
    return {
      rcps: [],
      loading: false,
      processamentosExpirados: false,
      arrTour: [
        {
          element: '#btn-novo-rcp',
          intro: 'Clicando neste botão você poderá criar um novo Relatório de Controle Patrimonial.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#rcp-historico-search',
          intro: 'Neste campo você poderá pesquisar pelos RCPs já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-rcp',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de seu RCP.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-rcp',
          intro: 'Aqui você acessa outras opções para seu RCP, como executá-lo novamente ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    };
  },

  mounted() {
    this.subscribe();
    this.getRcps();  
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refresh-rcps', () => {
        this.getRcps();
      });
    },
  
    getRcps() {
      this.loading = true;
      this.rcps = [];
      RcpService.getRcps(this.processamentosExpirados).then(response => {
        response.data.rcps.forEach(element => {

          let obj = {
            id: element.id,
            nome: element.nome,
            data_base: element.data_base ? dayjs(element.data_base.substr(0, 10)).format('DD/MM/YYYY') : '-',
            status: element.status,
            ultima_execucao: element.ultima_execucao ? dayjs(element.ultima_execucao).format('DD/MM/YYYY HH:mm') : '-',
            usuario: element.usuario.nome,
            usuario_id: element.usuario.id
          };
          this.rcps.push(obj);
        });
        
      })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar RCPS.', '', {position:'topRight'});
        })
        .finally(() => { this.loading = false, this.iniciarTourPagina();});
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.rcps.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>